import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';

// apicore
import { APICore, setAuthorization } from 'src/helpers/api/apiCore';

// api
import {
    creatEncounter as creatEncounterApi,
    updateEncounter as updateEncounterApi,
    getAllEncounter as getAllEncounterApi,
    getPatientAllEncounter as getPatientAllEncounterApi,
    getEncounter as getEncounterApi,
    getEncounterAddress as getEncounterAddressApi,
    getDiscountValue as getDiscountValueApi,
    updateEncounterTestData as updateEncounterTestDataApi,
    addEncounterTest as addEncounterTestApi,
    getEncounterTest as getEncounterTestApi,
} from './api';

// actions
import { encounterApiResponseSuccess, encounterApiResponseError } from './actions';

// constants
import { EncounterActionTypes } from './constants';

type EncounterData = {
    payload: any;
    type: string;
};

const api = new APICore();

/**
 * Add Encounter
 * @param {*} payload
 */
function* AddEncounter({ payload, type }: EncounterData): SagaIterator {
    try {
        const response = yield call(creatEncounterApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                encounterApiResponseSuccess(
                    EncounterActionTypes.ADD_ENCOUNTER,
                    data,
                    'Encounter has been created.',
                    code,
                    false,
                    true
                )
            );
        } else {
            let msg = `An error while creating Encounter!`;
            if (message) msg = message;
            yield put(encounterApiResponseSuccess(EncounterActionTypes.ADD_ENCOUNTER, data, msg, code, true, false));
        }
    } catch (error: any) {
        yield put(encounterApiResponseError(EncounterActionTypes.ADD_ENCOUNTER, [], error, 404, true, false));
    }
}

/**
 * Edit Encounter
 * @param {*} payload
 */
function* EditEncounter({ payload, type }: EncounterData): SagaIterator {
    try {
        const response = yield call(updateEncounterApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                encounterApiResponseSuccess(
                    EncounterActionTypes.EDIT_ENCOUNTER,
                    data,
                    'Encounter Get Updated Successfully',
                    code,
                    false,
                    true
                )
            );
        } else {
            let msg = `An error while edit Encounter!`;
            if (message) msg = message;
            yield put(encounterApiResponseSuccess(EncounterActionTypes.EDIT_ENCOUNTER, data, msg, code, true, false));
        }
    } catch (error: any) {
        yield put(encounterApiResponseError(EncounterActionTypes.EDIT_ENCOUNTER, [], error, 404, true, false));
    }
}

/**
 * Fetch Encounter
 * @param {*} payload
 */
function* GetEncounter({ payload, type }: EncounterData): SagaIterator {
    try {
        const response = yield call(getEncounterApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                encounterApiResponseSuccess(EncounterActionTypes.GET_ENCOUNTER, data, message, code, false, false)
            );
        } else {
            let msg = `An error while getting Encounter!`;
            if (message) msg = message;
            yield put(encounterApiResponseSuccess(EncounterActionTypes.GET_ENCOUNTER, data, msg, code, true, false));
        }
    } catch (error: any) {
        yield put(encounterApiResponseError(EncounterActionTypes.GET_ENCOUNTER, [], error, 404, true, false));
    }
}

/**
 * Fetch Encounters
 * @param {*} payload
 */
function* GetEncounters({ payload, type }: EncounterData): SagaIterator {
    try {
        const response = yield call(getAllEncounterApi, payload);
        const { data, message, success, code } = response.data;

        const responseData = typeof data === 'object' && Object.keys(data).length === 0 ? [] : data;
        if (code === 200 && success) {
            yield put(
                encounterApiResponseSuccess(
                    EncounterActionTypes.GET_ENCOUNTERS,
                    responseData,
                    message,
                    code,
                    false,
                    false
                )
            );
        } else {
            let msg = `An error while getting Encounter Listing!`;
            if (message) msg = message;
            yield put(
                encounterApiResponseSuccess(EncounterActionTypes.GET_ENCOUNTERS, responseData, msg, code, true, false)
            );
        }
    } catch (error: any) {
        yield put(encounterApiResponseError(EncounterActionTypes.GET_ENCOUNTERS, [], error, 404, true, false));
    }
}

/**
 * Fetch Encounters
 * @param {*} payload
 */
function* GetPatientEncounters({ payload, type }: EncounterData): SagaIterator {
    try {
        const response = yield call(getPatientAllEncounterApi, payload);
        const { data, message, success, code } = response.data;

        const responseData = typeof data === 'object' && Object.keys(data).length === 0 ? [] : data;
        if (code === 200 && success) {
            yield put(
                encounterApiResponseSuccess(
                    EncounterActionTypes.GET_PATIENT_ENCOUNTERS,
                    responseData,
                    message,
                    code,
                    false,
                    false
                )
            );
        } else {
            let msg = `An error while getting Encounter Listing!`;
            if (message) msg = message;
            yield put(
                encounterApiResponseSuccess(
                    EncounterActionTypes.GET_PATIENT_ENCOUNTERS,
                    responseData,
                    msg,
                    code,
                    true,
                    false
                )
            );
        }
    } catch (error: any) {
        yield put(encounterApiResponseError(EncounterActionTypes.GET_PATIENT_ENCOUNTERS, [], error, 404, true, false));
    }
}

/**
 * Fetch Encounter Address
 * @param {*} payload
 */
function* GetEncounterAddress({ payload, type }: EncounterData): SagaIterator {
    try {
        const response = yield call(getEncounterAddressApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                encounterApiResponseSuccess(
                    EncounterActionTypes.GET_ENCOUNTER_ADDRESS_INFO,
                    data,
                    message,
                    code,
                    false,
                    false
                )
            );
        } else {
            let msg = `An error while getting Encounter Address!`;
            if (message) msg = message;
            yield put(
                encounterApiResponseSuccess(
                    EncounterActionTypes.GET_ENCOUNTER_ADDRESS_INFO,
                    data,
                    msg,
                    code,
                    true,
                    false
                )
            );
        }
    } catch (error: any) {
        yield put(
            encounterApiResponseError(EncounterActionTypes.GET_ENCOUNTER_ADDRESS_INFO, [], error, 404, true, false)
        );
    }
}

/**
 * Fetch Encounter Test
 * @param {*} payload
 */
function* GetEncounterTest({ payload, type }: EncounterData): SagaIterator {
    try {
        const response = yield call(getEncounterTestApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                encounterApiResponseSuccess(
                    EncounterActionTypes.GET_ENCOUNTER_TEST_DATA,
                    data,
                    message,
                    code,
                    false,
                    false
                )
            );
        } else {
            let msg = `An error while getting Encounter Test Detail!`;
            if (message) msg = message;
            yield put(
                encounterApiResponseSuccess(EncounterActionTypes.GET_ENCOUNTER_TEST_DATA, data, msg, code, true, false)
            );
        }
    } catch (error: any) {
        yield put(encounterApiResponseError(EncounterActionTypes.GET_ENCOUNTER_TEST_DATA, [], error, 404, true, false));
    }
}

/**
 * Fetch Discount Value
 * @param {*} payload
 */
function* GetDiscountValue({ payload, type }: EncounterData): SagaIterator {
    try {
        const response = yield call(getDiscountValueApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                encounterApiResponseSuccess(EncounterActionTypes.GET_DISCOUNT, data, message, code, false, false)
            );
        } else {
            let msg = `An error while getting Discount!`;
            if (message) msg = message;
            yield put(encounterApiResponseSuccess(EncounterActionTypes.GET_DISCOUNT, data, msg, code, true, false));
        }
    } catch (error: any) {
        yield put(encounterApiResponseError(EncounterActionTypes.GET_DISCOUNT, [], error, 404, true, false));
    }
}

/**
 * Add Encounter Test
 * @param {*} payload
 */
function* AddEncounterTest({ payload, type }: EncounterData): SagaIterator {
    try {
        const response = yield call(addEncounterTestApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                encounterApiResponseSuccess(
                    EncounterActionTypes.ADD_ENCOUNTER_TEST,
                    data,
                    'Encounter Test has been created.',
                    code,
                    false,
                    true
                )
            );
        } else {
            let msg = `An error while creating Encounter Test!`;
            if (message) msg = message;
            yield put(
                encounterApiResponseSuccess(EncounterActionTypes.ADD_ENCOUNTER_TEST, data, msg, code, true, false)
            );
        }
    } catch (error: any) {
        yield put(encounterApiResponseError(EncounterActionTypes.ADD_ENCOUNTER_TEST, [], error, 404, true, false));
    }
}

/**
 * Add Encounter Test Data
 * @param {*} payload
 */
function* UpdateEncounterTestData({ payload, type }: EncounterData): SagaIterator {
    try {
        const response = yield call(updateEncounterTestDataApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                encounterApiResponseSuccess(
                    EncounterActionTypes.UPDATE_ENCOUNTER_TEST_DATA,
                    data,
                    'Encounter Test has been created.',
                    code,
                    false,
                    true
                )
            );
        } else {
            let msg = `An error while creating Encounter Test!`;
            if (message) msg = message;
            yield put(
                encounterApiResponseSuccess(
                    EncounterActionTypes.UPDATE_ENCOUNTER_TEST_DATA,
                    data,
                    msg,
                    code,
                    true,
                    false
                )
            );
        }
    } catch (error: any) {
        yield put(
            encounterApiResponseError(EncounterActionTypes.UPDATE_ENCOUNTER_TEST_DATA, [], error, 404, true, false)
        );
    }
}

export function* watchGetEncounter() {
    yield takeEvery(EncounterActionTypes.GET_ENCOUNTER, GetEncounter);
}

export function* watchGetEncounters() {
    yield takeEvery(EncounterActionTypes.GET_ENCOUNTERS, GetEncounters);
}

export function* watchGetPatientEncounters() {
    yield takeEvery(EncounterActionTypes.GET_PATIENT_ENCOUNTERS, GetPatientEncounters);
}

export function* watchAddEncounter() {
    yield takeEvery(EncounterActionTypes.ADD_ENCOUNTER, AddEncounter);
}

export function* watchAddEncounterTest() {
    yield takeEvery(EncounterActionTypes.ADD_ENCOUNTER_TEST, AddEncounterTest);
}

export function* watchEditEncounter(): any {
    yield takeEvery(EncounterActionTypes.EDIT_ENCOUNTER, EditEncounter);
}

export function* watchGetEncounterAddress() {
    yield takeEvery(EncounterActionTypes.GET_ENCOUNTER_ADDRESS_INFO, GetEncounterAddress);
}

export function* watchGetEncounterTest() {
    yield takeEvery(EncounterActionTypes.GET_ENCOUNTER_TEST_DATA, GetEncounterTest);
}

export function* watchUpdateEncounterTestData() {
    yield takeEvery(EncounterActionTypes.UPDATE_ENCOUNTER_TEST_DATA, UpdateEncounterTestData);
}

export function* watchDiscountValue() {
    yield takeEvery(EncounterActionTypes.GET_DISCOUNT, GetDiscountValue);
}

function* encounterSaga() {
    yield all([
        fork(watchGetEncounter),
        fork(watchAddEncounter),
        fork(watchEditEncounter),
        fork(watchGetEncounters),
        fork(watchGetEncounterAddress),
        fork(watchDiscountValue),
        fork(watchAddEncounterTest),
        fork(watchUpdateEncounterTestData),
        fork(watchGetPatientEncounters),
        fork(watchGetEncounterTest),
    ]);
}

export default encounterSaga;
